import { HtmlDocumentType } from '@/types';
import { createReducer } from 'deox';
import { loadHtmlActions } from '../actions/htmls';

export type HtmlsState = Record<HtmlDocumentType, string>;

const initialState = {} as HtmlsState;

const htmlsReducer = createReducer(initialState, (handleAction) => [
  handleAction(loadHtmlActions.success, (state, { payload }) => ({
    ...state,
    [payload.htmlDocumentType]: payload.html,
  })),
]);

export default htmlsReducer;
